module.exports = __webpack_public_path__ + "img/head.acf5f830.jpg";